export function sizeToPx(size: string) {
  switch (size) {
    case 'xl':
      return 80;
    case 'md':
      return 48;
    case 'sm':
      return 32;
    case 'lg':
    default:
      return 64;
  }
}
